<template>
  <div class="account-pages my-5">
    <div class="container">
      <div class="justify-content-center auth-container">
        <div class="card">
          <div class="card-body p-0">
            <div>
              <div v-if="config" class="mx-auto mb-5 login-header py-3">
                <div v-if="config && config.hasOwnProperty('logo')">
                  <span v-if="isReputationHub">
                    <img v-if="config.logo" :src="config.logo" style="display:block;margin:auto;max-width:320px;max-height:80px;"/>
                    <img v-else
                         src="@assets/images/repuagency-logo.png"
                         style="display:block;margin:auto;max-width:200px;"
                    />
                  </span>
                  <span v-else-if="isRepuAgency">
                    <img v-if="config.logo" :src="config.logo" style="display:block;margin:auto;max-width:320px;max-height:80px;"/>
                    <img v-else-if="origin.includes('repuagency.com')"
                         src="@assets/images/repuagency-logo.png"
                         style="display:block;margin:auto;max-width:200px;"
                    />
                  </span>
                  <img v-else-if="config.logo" :src="config.logo" style="display:block;margin:auto;max-width:320px;max-height:80px;"/>
                  <img v-else-if="origin === 'https://app.showmyrep.io' || origin.includes('rvrply.com')" src="@assets/images/Blank.png" style="display:block;margin:auto;height:60px;max-width:100%;"/>
                  <img v-else-if="origin.includes('tapengine.io')" src="@assets/images/tapengine-logo.png" style="display:block;margin:auto;height:60px;max-width:100%;"/>
                  <img v-else-if="origin.includes('getsocialreviews.com')" src="@assets/images/social-review-logo.png" style="display:block;margin:auto;height:60px;max-width:100%;"/>
                  <img v-else-if="origin.includes('reviewsurge.co')" src="@assets/images/review-surge-logo.png" style="display:block;margin:auto;height:50px;max-width:100%;"/>
                  <img v-else-if="origin.includes('leadmachine.io')" src="@assets/images/lead-machine-logo.png" style="display:block;margin:auto;height:25px;max-width:100%;"/>
                  <img v-else-if="origin.includes('socialfusionai.com')" src="@assets/images/social-fusion-logo.png" style="display:block;margin:auto;height:25px;max-width:100%;"/>
                  <img v-else-if="origin.includes('instastream.co')" src="@assets/images/insta-stream-logo.png" style="display:block;margin:auto;height:25px;max-width:100%;"/>
                  <img v-else-if="isZenSocial" src="@assets/images/zensocial-logo.png" style="display:block;margin:auto;height:60px;max-width:100%;"/>
                  <img v-else src="@assets/images/logo.png" style="display:block;margin:auto;height:60px;max-width:100%;"/>
                </div>
              </div>
              <div class="pr-5 pl-5 pb-5">
                <h6 class="h5 mb-0 mt-4">Forgot password!</h6>
                <p class="text-muted mt-1 mb-4">
                  Enter your email address
                </p>
                <ValidationObserver v-slot="{ handleSubmit }">
                  <form
                    class="login-form"
                    @submit.prevent="handleSubmit(handleSend)"
                  >
                    <div class="form-group">
                      <div class="input-group input-group-merge">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <feather
                              type="mail"
                              class="align-middle icon-dual"
                            ></feather>
                          </span>
                        </div>
                        <b-form-input
                          v-model="credentials.email"
                          type="text"
                          required
                          placeholder="Enter email"
                        ></b-form-input>
                      </div>
                    </div>
                    <b-form-group v-if="!agencies.length" id="button-group" class="mt-4 mb-1">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="btn-block btn-dark-blue"
                        :disabled="loadingSend"
                      >
                        <b-spinner v-if="loadingSend" small /> Send
                      </b-button>
                    </b-form-group>
                    <div v-if="agencies.length > 1" class="form-group mt-3">
                      <label for="agency-select">Select your agency</label>
                      <b-form-select v-model="selectedAgency" :options="agencies.map(a => ({ value: a.id, text: a.name }))" required />
                      <b-button class="btn-block btn-dark-blue mt-3" :disabled="!selectedAgency || loadingSend" @click="sendReset(credentials.email, selectedAgency)">
                        <b-spinner v-if="loadingSend" small /> Send
                      </b-button>
                    </div>
                    <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
                    <div class="text-center mt-4">
                      <router-link :to="{ name: 'login' }"
                        >Back to Login</router-link
                      >
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      credentials: {
        email: '',
      },
      origin: window.location.origin,
      loadingSend: false,
      agencies: [], // Agencies for the email
      selectedAgency: '', // Selected agency_id
      error: '',
      success: false,
    }
  },

  computed: {
    config() {
      return this.$store.getters['app/config']
    },
  },

  methods: {
    handleSend() {
      this.loadingSend = true;
      this.error = '';
      this.success = false;
      this.agencies = [];
      this.selectedAgency = '';
      this.$store
        .dispatch('auth/forgotPassword', this.credentials)
        .then((response) => {
          this.loadingSend = false;
          // If success is false and agencies are present, show dropdown
          if (response && response.success === false && response.agencies && response.agencies.length > 1) {
            this.agencies = response.agencies;
            return;
          }
          // If only one agency, send reset immediately
          if (response && response.success === false && response.agencies && response.agencies.length === 1) {
            this.sendReset(this.credentials.email, response.agencies[0].id);
            return;
          }
          // If success is true, redirect to login
          if (response && response.success === true) {
            this.$router.push({ name: 'login' });
            return;
          }
          // If no agencies and not successful, show error
          if (response && response.success === false && (!response.agencies || response.agencies.length === 0)) {
            this.error = 'No matching user found for this email.';
          }
        })
        .catch((err) => {
          this.loadingSend = false;
          this.error = err && err.message ? err.message : 'Error sending password reset.';
        });
    },
    sendReset(email, agencyId) {
      this.loadingSend = true;
      this.$store
        .dispatch('auth/forgotPassword', { email, agencyId })
        .then((response) => {
          this.loadingSend = false;
          if (response && response.success === true) {
            this.$router.push({ name: 'login' });
          } else if (response && response.success === false && response.agencies && response.agencies.length > 1) {
            this.agencies = response.agencies;
          } else if (response && response.success === false) {
            this.error = 'Unable to reset password for this agency.';
          }
        })
        .catch((err) => {
          this.loadingSend = false;
          this.error = err && err.message ? err.message : 'Error sending password reset.';
        });
    },
  },
}
</script>

<style lang="scss" scoped>
.login-header{
  background: #1e3260;
}
.auth-container {
  width: 460px;
  max-width: 100%;
  margin: 0 auto;
  margin-top: 15vh;
  .custom-control-label {
    &:before,
    &:after {
      width: 20px;
      height: 20px;
      top: 0px;
    }
  }

  .input-group-text {
    padding: 5px 10px;
  }
}
</style>
